import { sortBy } from 'lodash';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import parseDatabaseValue from 'utilities/parseDatabaseValue';
import { KPI_DATA_ROW_START_INDEX } from './constants';
import { KpiCell, KpiColumn, KpiReverseParserType } from './types';

const reverseParser = ({ cells, columns, allowEmptyValues, rowConfig, fieldAttributes }: KpiReverseParserType) => {
  let tableColumns: KpiColumn[] = [];
  const { kpiAttrs } = fieldAttributes;
  const decimalPlaces = kpiAttrs?.kpi_value?.decimal_places ?? 4;

  const sortedColumns = sortBy(columns, ['order']);
  const alphabet = alphabetGenerator([], sortedColumns.length);

  sortedColumns.forEach((column, columnIndex) => {
    const columnLegend = alphabet[columnIndex];

    // copy original values
    const tmpColumn = { ...column };
    const kpiDataSet: KpiColumn['kpi_dataset'] = [];

    // replace updated values
    rowConfig.forEach((cell: ICell, cellIndex: number) => {
      if (cellIndex < KPI_DATA_ROW_START_INDEX) {
        return;
      }

      const key = columnLegend + (cellIndex + 1);
      const defaultValue = cell.defaultValue || null;
      const type = cell.dbType || null;
      const format = cell.format || null;
      const value = cells[key] ? (cells[key] as ICell).value : defaultValue;
      const { gridType } = cell;

      const parsedValue = parseDatabaseValue({
        type,
        value,
        format,
        allowEmptyValues,
        gridType,
        decimalPlaces,
      });

      if (cell.alias && cells[key as keyof typeof cells]) {
        kpiDataSet.push({
          company_kpi: {
            ref: cell.alias, // this way we can map things correctly when writing new KPIs in the backend
            sort_order: cellIndex - KPI_DATA_ROW_START_INDEX,
          },
          id: (cells[key as keyof typeof cells] as KpiCell).kpiId,
          kpi_value: parsedValue,
        });
      }
    });
    tmpColumn.kpi_dataset = kpiDataSet;

    tableColumns = [...tableColumns, tmpColumn];
  });

  return tableColumns;
};

export default reverseParser;
